import { Locale } from 'contentful';
import { TypeLocationSkeleton, TypeMedia } from '@/@types/generated/contentful';
import MultiLocaleService from './base/MultiLocaleService';
import ILocation from '../types/base/ILocation';

export default class LocationService extends MultiLocaleService {
	public async getLocations(): Promise<Record<string, ILocation[]>> {
		const locations = await this.deliveryClient.withAllLocales.getEntries<TypeLocationSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'location',
			limit: 1000,
		});

		const locationsByLocaleCode: Record<string, ILocation[]> = {};

		this.locales.forEach((locale: Locale): void => {
			locationsByLocaleCode[locale.code] = locations.items.map(
				(location): ILocation => {

					const image = location.fields.image as Record<string, TypeMedia<'WITH_ALL_LOCALES'>> | undefined;

					return {
						...this.mapToSingleLocaleObject(location.fields, locale),
						id: location.sys.id,
						image:
							image?.de.fields.asset.de
					};
				}
			);
		});

		return locationsByLocaleCode;
	}
}
